<template>
	<div class="layout-profile">
		
		<div>
			<img v-if="imgSrc != 'data:imagem/jpeg;base64,' && imgSrc != ''" class="avatarExistente" :src="imgSrc"
				@click="AbrirModalFoto()" style="cursor: pointer">
			<img v-else class="avatar" src="../public/assets/layout/images/default-avatar.jpg" alt=""
				@click="AbrirModalFoto()" style="cursor: pointer" />
		</div>

		<button class="p-link layout-profile-link perfil-botao" @click="onClick">
			<div class="p-grid">
				<div class="p-col-8 p-offset-2">
					<span class="username"> {{ userName ? userName : 'Carregando...' }}</span>
					<i class="pi pi-fw pi-cog"></i>
				</div>
				<div class="p-col-6 vinculo">
					<span class="vinculo"> Vínculo {{ vinculo }}</span>
				</div>
				<div class="p-col-6 vinculo" v-if="pensao">
					<span class="vinculo"> Num. Pensão {{ pensao }}</span>
				</div>
			</div>
		</button>
		<transition name="layout-submenu-wrapper">
			<ul v-show="expandedProfile">
				<!-- <li><button class="p-link" @click="AbrirModalFoto()"><i class="pi pi-fw pi-image"></i><span>Adicionar/Alterar Foto Servidor</span></button></li> -->
				<li><button class="p-link" @click="trocarSenha()"><i class="pi pi-fw pi-key"></i><span>Alterar
							Senha</span></button></li>
				<li><button class="p-link" @click="trocarVinculo()"><i class="pi pi-fw pi-share-alt"></i><span>Alterar
							Vínculo</span></button></li>
				<li><button class="p-link" @click="logout()"><i
							class="pi pi-fw pi-power-off"></i><span>Sair</span></button></li>
			</ul>
		</transition>
		<Dialog :visible.sync="modalFoto" header="Adicione/Altere sua Foto" :modal="true" maximizable
			:contentStyle="'max-width:80rem; max-height:80rem; width:80rem; height:80rem'" >
			<div class="p-grid p-fluid">
				<div class="p-col-12">
					<Rotulo cols="12 6 6">
						<span style="text-align: left;">
							<strong>
								<p>Siga os passos a seguir para concluir essa Etapa: </p>
							</strong>
						</span>
					</Rotulo>
					<Rotulo cols="12 12 12">
						<div class="avisos">
							<ol>
								<li class="passosSeguir">
									Escolha um lugar bem iluminado;
								</li>
								<li class="passosSeguir">
									Utilize um fundo branco ou claro;
								</li>
								<li class="passosSeguir">
									Não use óculos escuros, nem chapéu, nem boné, nem similares;
								</li>
								<li class="passosSeguir">
									Não deixar os cabelos cobrir as orelhas;
								</li>
								<li class="passosSeguir">
									Mantenha os olhos abertos.

								</li>
							</ol>
						</div>
						<div class="p-col-12">
							<FileUpload :customUpload="true" mode="basic"
								chooseLabel="Selecionar Imagem (JPEG e PNG de até 2Mb)"
								invalidFileSizeMessage="Tamanho Máximo do Arquivo Não Permitido. Tamanho Máximo de {1}."
								invalidFileTypeMessage="Tipo de Arquivo Não Permitido. Tipos Permitidos são PNG e JPEG"
								accept="image/*" @select="onUploadFoto" ref="fileupload" :maxFileSize="2000000" />
							<br>
							<div v-if="imgSrc != 'data:imagem/jpeg;base64,'">
								<vue-cropper ref="cropper" :guides="true" :view-mode="2" drag-mode="crop"
									:auto-crop-area="0.5" :min-container-width="250" :min-container-height="180"
									:background="true" :rotatable="false" :src="imgSrc" alt="Source Image"
									:img-style="{ 'width': '800px', 'height': '600px' }" :aspect-ratio="3 / 4"
									:outputSize="0.5" v-if="imgSrc">

								</vue-cropper>
							</div>
							<div v-else  class='p-col-12'>
									<div style="border-color: blue;  height: 300px; border:dashed">
											<!-- <span><strong>SUA FOTO IRÁ APARECER AQUI!</strong></span> -->
									</div>
							</div>

						</div>
					</Rotulo>
					<Rotulo cols="12 6 12">
						<Button @click="cropImage" label="Cortar Imagem" v-if="imgSrc != ''"
							style="margin-right: 40px;" />
					</Rotulo>
					

				</div>

			</div>
		</Dialog>
	</div>

</template>

<script>
import { mapState } from 'vuex'
import { baseApiUrl } from '@/config/global'	
import Rotulo from '@/template/RotuloSeplag.vue'	
import VueCropper from 'vue-cropperjs';

import 'cropperjs/dist/cropper.css';
import axios from 'axios'

export default {
	components: { Rotulo, VueCropper },
	data: function () {		

		return {
			vinculo: this.$store.getters.getVinculo,
			pensao: null,
			// variaveis para o upload de foto do servidor
			modalFoto: false,
			preview: null,
			image: null,
			imgSrc: "",
			cropImg: "",
			imgDef: "",
			file: null,
			file2: null,
			mime_type: "image/jpeg",
			selectedFile: '',
			files: '',
			imagemFoto: null,
			tamanhoFoto: null,
			aux: null,
			auxidFoto: null,
			sad: '',
			dadosPessoa: []
		}
	},
	props: {
		ontrocarSenha: {
			// Evento disparado para enviar link de ativação
			type: Function
		},
		ontrocarVinculo: {
			// Evento disparado para enviar link de ativação
			type: Function
		},
		podeDadosPessoais :{
			default: true,
			type: Boolean
		}
	},
	methods: {
		// ...mapActions(['refreshToken','logarUsuario']),
		onClick(event) {
			this.$store.commit("setExpandedProfile",!this.expandedProfile)     
			event.preventDefault();
		},
		logout() {

			if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != 'false') {
				this.$recaptchaInstance.showBadge()
			}
			this.$store.dispatch('logoutUsuario')
			if (this.$route.name != 'dashboard') {
				this.$router.push({ name: 'dashboard' })
			}
		},
		refresh() {
			this.$store.dispatch('refreshToken', this)
		},
		trocarSenha() {
			this.ontrocarSenha()
		},
		trocarVinculo() {
			this.ontrocarVinculo()
		},
		fechaMenuProfile() {
			this.$store.commit("setExpandedProfile",!this.expandedProfile)     
		},
		onUploadFoto(e) {
			if (e.files && e.files.length > 0) {
				if (e.files[0].size > 2000000) {
					this.$toast.add({ severity: 'error', summary: 'Erro ao enviar o arquivo', detail: "O tamanho do arquivo excede 2 Mbs, por favor informe um arquivo com até 2 Mbs.", life: 5000 });
				} else {
					this.imgSrc = null
					this.loaderTrue = true;
					this.file = e.files[0]
					// this.file2 = e
					const file = e.files[0];
					const reader = new FileReader();
					reader.onload = event => {
						//imagem para aparecer na tela para corte
						this.imgSrc = event.target.result
					};
					reader.readAsDataURL(file);
				}
			}
		},
		resizeImage(index, file, method) {
			const reader = new FileReader()
			reader.onload = readerEvent => {
				const img = new Image()
				//aqui começa o processo de redimensionamento da imagem
				img.onload = () => {
					const { width, height } =
						method === 1
							? this.aspectRatio(300)
							: this.proportionalResize(img.width, img.height)
					const canvas = document.createElement("canvas")
					canvas.width = width
					canvas.height = height
					canvas.getContext("2d").drawImage(img, 0, 0, width, height)
					this.images[index].content = canvas.toDataURL(
						"image/jpeg",
					)
				}
				img.src = readerEvent.target.result
			}
			reader.readAsDataURL(file)

		},
		cropImage() {
			this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
			this.modalFoto = false
			this.imgSrc = ""
			var canvas = this.$refs.cropper.getCroppedCanvas()
			var ctx = canvas.getContext("2d");

			var MAX_WIDTH = 900;
			var MAX_HEIGHT = 700;

			var width = 400;
			var height = 300;

			if (width > height) {
				if (width > MAX_WIDTH) {
					height *= MAX_WIDTH / width;
					width = MAX_WIDTH;
				}
			} else {
				if (height > MAX_HEIGHT) {
					width *= MAX_HEIGHT / height;
					height = MAX_HEIGHT;
				}
			}
			if (canvas.width > MAX_WIDTH && canvas.height > MAX_HEIGHT) {

				canvas.width = width;
				canvas.height = height;

				ctx.drawImage(this.$refs.cropper.getCroppedCanvas(), 0, 0);

				this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
					this.tamanhoFoto = blob;
					const formData = new FormData()
					formData.append('file', blob, 'name.jpeg')
					axios.post(`${baseApiUrl}/fotoPessoal/upload/${this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa}`, formData).then(res => {
						this.aux = this.cropImg
						this.auxidFoto = res.data.idenArquivoDadoPessoal
						this.$toast.add({
							severity: 'success',
							summary: "Foto adicionada com sucesso!",
							life: 3000
						})
						axios.get(`${baseApiUrl}/fotoPessoal/${this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa}`).then(res => {
							if (res.status == 200) {
								if (res != null) {
									this.imgSrc = "data:imagem/jpeg;base64," + res.data

								}
							}
						}
						)
					}

					)

				}, this.mime_type, 0.5)
			} else {

				this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
					this.tamanhoFoto = blob;
					const formData = new FormData()
					formData.append('file', blob, 'name.jpeg')
					axios.post(`${baseApiUrl}/fotoPessoal/upload/${this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa}`, formData).then(res => {
						this.aux = this.cropImg
						this.auxidFoto = res.data.idenArquivoDadoPessoal
						this.$toast.add({
							severity: 'success',
							summary: "Foto adicionada com sucesso!",
							life: 3000
						})
						axios.get(`${baseApiUrl}/fotoPessoal/${this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa}`).then(res => {
							if (res.status == 200) {
								if (res != null) {
									this.imgSrc = "data:imagem/jpeg;base64," + res.data

								}
							}
						}
						)
						//window.location.reload()
					}

					)

				}, this.mime_type)
			}
		},
		AbrirModalFoto() {
			this.modalFoto = true;
		},
		carregaFotoExistente() {
			if(this.$store.getters.getUser && this.$store.getters.getUser.dadosUsuariosCustomizados.arquivoFoto != null){
				axios.get(`${baseApiUrl}/fotoPessoal/${this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa}`).then(res => {
					if (res.status == 200) {
						if (res != null) {
							this.imgSrc = "data:imagem/jpeg;base64," + res.data

						}
					}
				}
				)
			}
		},
	},
	computed: {
		...mapState(['userName','expandedProfile']),
		verificaVinculo() {
			return this.$store.getters.getVinculo
		},
		verificaPensao(){
			return this.$store.getters.getUser && 
					this.$store.getters.getUser.dadosUsuariosCustomizados && 
					this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoERP &&
					this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoERP.numrPensionista>0? 
						this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoERP.numrPensionista : 
							null
		},
		abrirModalTrocaFoto(){
			return this.$store.getters.getExibirModalTrocaFoto;
		},
		possuiPessoaCarregada(){
			return this.$store.getters.getUser? true : false
		}

	},
	watch: {
		verificaVinculo(newVinculo) {
			this.vinculo = newVinculo
		},		
		verificaPensao(newPensao) {
			this.pensao = newPensao
		},
		abrirModalTrocaFoto(){
			this.AbrirModalFoto()
		},
		possuiPessoaCarregada(novaPessoa){
			if(novaPessoa){
				this.carregaFotoExistente()
			}
		}
	},
    mounted(){
		this.carregaFotoExistente()
    }
}
</script>
<style scoped>
.avatar {
	border-radius: 50%;
	width: 50px;
}

.avatarExistente {
	width: 70px;
	border-radius: 20%;
	min-width: 20%;
}

.perfil-botao {
	text-align: center;
	min-width: 95%;
}

.vinculo {
	margin-left: 19%;
}

.avisos {
	background-color: rgb(231 232 125 / 84%);
	color: #000000;
	border-radius: 12px;
	padding-left: 15px;
	text-align: left;
}

.arquivoRejeitado {
	margin-top: 25px;

}

.passosSeguir {
	list-style-type: decimal-leading-zero;
	margin-left: 3vw;
	margin: 6.5px 0px 6.5px 3vw;
}

@media screen and (max-width: 40em) {
	.passosSeguir {
		margin-left: 9vw;
		text-align: justify;
	}
}

input[type="file"] {
	display: none;
	width: 100%;
	height: 100%;
	padding: -10px;
}

.custom-file-upload {
	border: 1px solid #ccc;
	display: inline-block;
	padding: 6px 12px;
	cursor: pointer;
}
</style>